module.exports = __webpack_public_path__ + "static/img/donate-blood-04.c01c051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/donate-blood-04.jpg
// module id = ZXIO
// module chunks = 99